/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TimesheetReport,
} from '../models/index';
import {
    TimesheetReportFromJSON,
    TimesheetReportToJSON,
} from '../models/index';

export interface GetTimesheetPerformanceReportRequest {
    year: number;
}

export interface GetTimesheetUtilisationReportRequest {
    year: number;
}

/**
 * 
 */
export class TimesheetApi extends runtime.BaseAPI {

    /**
     * Aggregates the timesheeted hours per financial quarter showing the entered number of hours compared to the  contracted number of core hours, along with a percentage and annual total. Same as the Utilisation report but excludes admin hours.  Only MANAGER and ADMIN roles can view this: 
     * Performance report of worked hours per year, excluding admin hours
     */
    async getTimesheetPerformanceReportRaw(requestParameters: GetTimesheetPerformanceReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TimesheetReport>> {
        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling getTimesheetPerformanceReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/timesheets/report/performance/{year}`.replace(`{${"year"}}`, encodeURIComponent(String(requestParameters['year']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TimesheetReportFromJSON(jsonValue));
    }

    /**
     * Aggregates the timesheeted hours per financial quarter showing the entered number of hours compared to the  contracted number of core hours, along with a percentage and annual total. Same as the Utilisation report but excludes admin hours.  Only MANAGER and ADMIN roles can view this: 
     * Performance report of worked hours per year, excluding admin hours
     */
    async getTimesheetPerformanceReport(requestParameters: GetTimesheetPerformanceReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TimesheetReport> {
        const response = await this.getTimesheetPerformanceReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aggregates the timesheeted hours per financial quarter showing the entered number of hours compared to the  contracted number of core hours, along with a percentage and annual total.  The response content will change based on access role:  * SITE: will receive only their own timesheet entry. * PROJECT: will receive only their own timesheet entry. * SITEMANAGER: will receive all SITE and SITEMANAGER entries. * OPERATIONMANAGER: will receive all PROJECT and OPERATIONMANAGER entries. * ADMIN: will receive all entries regardless of role. 
     * Utilisation report of worked hours per year
     */
    async getTimesheetUtilisationReportRaw(requestParameters: GetTimesheetUtilisationReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TimesheetReport>> {
        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling getTimesheetUtilisationReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/timesheets/report/utilisation/{year}`.replace(`{${"year"}}`, encodeURIComponent(String(requestParameters['year']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TimesheetReportFromJSON(jsonValue));
    }

    /**
     * Aggregates the timesheeted hours per financial quarter showing the entered number of hours compared to the  contracted number of core hours, along with a percentage and annual total.  The response content will change based on access role:  * SITE: will receive only their own timesheet entry. * PROJECT: will receive only their own timesheet entry. * SITEMANAGER: will receive all SITE and SITEMANAGER entries. * OPERATIONMANAGER: will receive all PROJECT and OPERATIONMANAGER entries. * ADMIN: will receive all entries regardless of role. 
     * Utilisation report of worked hours per year
     */
    async getTimesheetUtilisationReport(requestParameters: GetTimesheetUtilisationReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TimesheetReport> {
        const response = await this.getTimesheetUtilisationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
